import React, { useState } from 'react'
import Header from '../Includes/Header'
import Footer from '../Includes/Footer'
import internetBanner from "../Includes/Images/video-banner-02.jpg"
import "../Components/Providers/Provider.css"
import './Internet.css'

function Internet() {
  return (
    <>
      <Header />
      <section className="xfn-hero">
        <div className="xfn-container">
          <div className="xfn-hero-content">
            <div className="xfn-hero-left">
              <h1 className="xfn-hero-title">Discover the Best Internet Providers Near You</h1>
              <p className="xfn-hero-text">Be a part of our 5M+ satisfied customers</p>
              <a href="tel:+1-888-348-6689" className="xfn-cta-button">
                <i className="xfn-phone-icon"></i>
                +1-888-348-6689
              </a>
              <p className="xfn-fine-print">*For 12 months, 1-year term contract. Taxes and equipment not included. Incl. up to $10/mo. auto-pay & paperless bill discount. Prices, speeds, and package availability may vary from area to area.</p>
            </div>
            <div className="xfn-hero-right">
              <img src={internetBanner} alt={`banner`} className="xfn-hero-img" />
            </div>
          </div>
        </div>
      </section>

      <div className="section-heading">
        <h2>Compare Top Internet Providers in Your Area        </h2>
        <p>Get high-speed internet with incredible bundle deals. Compare packages, speeds, and pricing. Learn about DSL, satellite, cable, and fiber optic availability from leading providers in your area.

        </p>
      </div>

      <div className="table-container">
        <table className="comparison-table">
          <thead>
            <tr className="comparison-header">
              <th>Service</th>
              <th>Movie Count </th>
              <th>TV Show Count </th>
              <th>Starting Monthly Price </th>
              <th>Max Simultaneous Streams</th>
            </tr>
          </thead>
          <tbody>
            <tr className="comparison-row">
              <td className="provider-logo">Netflix </td>
              <td>3,714 </td>
              <td>1,941 </td>
              <td>$7 </td>
              <td>4</td>
            </tr>
            <tr className="comparison-row">
              <td className="provider-logo">Prime Video</td>
              <td>66,021</td>
              <td>10,853</td>
              <td>$9</td>
              <td>3</td>
            </tr>
            <tr className="comparison-row">
              <td className="provider-logo">Max</td>
              <td>2,047</td>
              <td>613</td>
              <td>$10</td>
              <td>4</td>
            </tr>
            <tr className="comparison-row">
              <td className="provider-logo">Hulu</td>
              <td>1,172</td>
              <td>1,254 </td>
              <td>$8 </td>
              <td>2</td>
            </tr>
            <tr className="comparison-row">
              <td className="provider-logo">Disney Plus </td>
              <td>953 </td>
              <td>325 </td>
              <td>$8 </td>
              <td>4</td>
            </tr>
            <tr className="comparison-row">
              <td className="provider-logo">Peacock</td>
              <td>900 </td>
              <td>300 </td>
              <td>$6 </td>
              <td>3</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="footnotes">
        <div className="footnote-item">1: No term contract. Does not include broadcast TV fee and regional sports fee; price subject to change. Taxes and equipment not included. Automatic payments and paperless billing required.</div>
        <div className="footnote-item">2: Limited time offer; subject to change: new residential customers only (no Spectrum services within past 30 days) and in good standing with Spectrum. SPECTRUM TV SELECT: Standard rates apply after promo period. TV equipment may be required, charges apply. Channel availability based on level of service and not all channels available in all markets or locations. Services subject to all applicable service terms and conditions, subject to change. Services not available in all areas. Restrictions apply. ©2024 Charter Communications, all rights reserved.</div>
        <div className="footnote-item">3: Every day low price. No annual contract.</div>
        <div className="footnote-item">4: View <a href="#" className="pricing-link">Full Disclaimer</a>.</div>
      </div>



      <div className="section-heading">
        <h2>Compare Top Internet Providers in Your Area        </h2>
        <p>Get high-speed internet with incredible bundle deals. Compare packages, speeds, and pricing. Learn about DSL, satellite, cable, and fiber optic availability from leading providers in your area.
        </p>
        <div className="icons-container">
          <div className="icon-item">
            <i className="fas fa-earth"></i>
            <span className="icon-text">100% US coverage</span>
          </div>
          <div className="icon-item">
            <i className="fas fa-thumbs-up"></i>
            <span className="icon-text">5M+ satisfied customers
            </span>
          </div>
          <div className="icon-item">
            <i className="fas fa-user"></i>
            <span className="icon-text">30+ internet brand partners
            </span>
          </div>
          <div className="icon-item">
            <i className="fas fa-archive"></i>
            <span className="icon-text">1500+ Resource Archive
            </span>
          </div>
        </div>
      </div>
      <div className="info-box">
        <div className="info-text">
          <h3>How We Evaluate?</h3>
          <p>
            Our recommendations are no hit-or-miss. We rely on the rigorous research done by our tech experts who unbiasedly evaluate providers based on performance, affordability, reliability, security, value, and customer satisfaction.

          </p>
        </div>
      </div>

      <div class="isp_container">
    <div class="isp_card">
        <div class="isp_header">
            <div class="isp_logo_section">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Xfinity_Logo.svg/2560px-Xfinity_Logo.svg.png" alt="Xfinity Logo" class="isp_logo"/>
            </div>
            <div class="isp_title_section">
                <h2 class="isp_provider_title">Best Cable Internet Provider</h2>
                <p class="isp_price_range">Price range: <strong>$19.99/mo. – $85.00/mo.*</strong> <span class="isp_small_text">(varies by location)</span></p>
            </div>
        </div>
        
        <div class="isp_content">
            <div class="isp_features_section">
                <div class="isp_feature">
                    <span class="isp_checkmark">✓</span>
                    <span>Wide Availability</span>
                </div>
                <div class="isp_feature">
                    <span class="isp_checkmark">✓</span>
                    <span>Diverse plan options</span>
                </div>
                <div class="isp_feature">
                    <span class="isp_checkmark">✓</span>
                    <span>xFi Gateway</span>
                </div>
            </div>
            
            <div class="isp_pricing_section">
                <div class="isp_pricing_item">
                    <span class="isp_icon">?</span>
                    <span>Price changes</span>
                </div>
                <div class="isp_pricing_item">
                    <span class="isp_icon">?</span>
                    <span>Equipment fees</span>
                </div>
            </div>
            
            <div class="isp_cta_section">
                <div class="isp_call_text">Call to Order</div>
                <a href="tel:8445722220" class="isp_cta_button">
                    <span class="isp_phone_icon">📞</span>
                    (844) 572-2220
                </a>
            </div>
        </div>
        
        <div class="isp_footer">
            <p class="isp_description_text">Xfinity stands out as one of the leading internet providers nationwide, offering a <a href="#" class="isp_link">wide range of plans</a> in over 40 states. Its superfast speeds and seamless connectivity allow you to perform various online activities such as streaming, gaming, surfing, and more without interruption.</p>
            <p class="isp_description_text">What's more, subscribers are also eligible to receive the Xfinity xFi Gateway for enhanced reliability and smooth browsing experience.</p>
            <p class="isp_footnote">*Taxes not included. Additional equipment fee may apply. Automatic payments and paperless billing required.</p>
        </div>
    </div>
</div>
      {/* <CustomMap /> */}
      <Footer />
    </>
  )
}

export default Internet